import { initialUserConfigState, UserConfigActionTypes } from '../types';
import createAsyncMapReducer from '~lib/shared/redux/reducers/async-map-reducer';
const getConfigByIdReducer = createAsyncMapReducer(UserConfigActionTypes.GET_CONFIG_BY_ID, initialUserConfigState.getConfigById);
export default getConfigByIdReducer;
